export const VEHICLE_TYPE_COLORS = {
  car: '#2F80ED',
  '2w': '#F2994A',
  '3w': '#9B51E0',
  mb: '#6FCF97',
  bus: '#27AE60',
  ab: '#1F8B4C',
  lcv: '#00A6A6',
  hdv: '#4B5563',
  '4W': '#2F80ED',
  '2W': '#F2994A',
  '3W': '#9B51E0',
  MB: '#6FCF97',
  Bus: '#27AE60',
  AB: '#1F8B4C',
  LCV: '#00A6A6',
  HDV: '#4B5563'
}

export const POWERTRAIN_COLORS = {
  Petrol: '#2F80ED',
  Diesel: '#5B6472',
  'Petrol ICE': '#2F80ED',
  'Diesel ICE': '#5B6472',
  BEV: '#27AE60',
  FCEV: '#00A6A6'
}

export const VEHICLE_PRICE_COLORS = {
  'Petrol Car': '#2F80ED',
  'BEV Car': '#27AE60',
  'Diesel LCV': '#5B6472',
  'BEV LCV': '#009B72',
  'Petrol 2W': '#F2994A',
  'BEV 2W': '#7CB518',
  'Petrol 3W': '#9B51E0',
  'BEV 3W': '#2FBF71',
  'Diesel Bus': '#8D6E63',
  'BEV Bus': '#00A86B',
  'Diesel HDV': '#374151',
  'BEV HDV': '#1B7F5A'
}

export const TCO_COST_COLORS = {
  'Capital costs': '#2F80ED',
  'NPV of fuel costs': '#F2994A',
  'NPV of maintenance costs': '#6C5CE7',
  'NPV of battery change costs': '#27AE60',
  'Charging Infra.': '#00A6A6',
  Infrastructure: '#00A6A6'
}

export const PIE_CHART_COLORS = [
  '#2F80ED',
  '#27AE60',
  '#F2994A',
  '#9B51E0',
  '#00A6A6',
  '#4B5563'
]

export const DEFAULT_CHART_COLOR = '#607D8B'

export function getVehicleTypeColor(vehicleType) {
  return VEHICLE_TYPE_COLORS[vehicleType] || DEFAULT_CHART_COLOR
}

export function getPowertrainColor(label) {
  return POWERTRAIN_COLORS[label] || DEFAULT_CHART_COLOR
}

export function getVehiclePriceColor(label) {
  return VEHICLE_PRICE_COLORS[label] || DEFAULT_CHART_COLOR
}

export function getTcoCostColor(label) {
  return TCO_COST_COLORS[label] || DEFAULT_CHART_COLOR
}
